var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "news",
              label: _vm.$t(_vm.title_news),
              icon: "fal fa-newspaper"
            },
            slot: "title"
          }),
          _c("q-tab-pane", { attrs: { name: "news" } }, [
            _c("div", { staticClass: "row gutter-md" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [_c("filter-news", { on: { changeFilter: _vm.changeFilter } })],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-9",
                  staticStyle: { "min-height": "700px" }
                },
                [
                  _vm.news.length == 0
                    ? _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-12 q-ma-lg text-center"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("searched_term_returned_no_results")
                              ) +
                              "\n                    "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12", attrs: { else: "" } },
                    [
                      _c(
                        "q-infinite-scroll",
                        {
                          ref: "news_scroll",
                          attrs: { handler: _vm.getNews, offset: 500 }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row gutter-md" },
                            _vm._l(_vm.news, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.id,
                                  staticClass: "col-xs-12 col-sm-4"
                                },
                                [
                                  _c("news-card", {
                                    attrs: { news: item },
                                    on: { showNews: _vm.showNews }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ],
        1
      ),
      _c("modal-notification", {
        attrs: { show_modal: _vm.show_modal, id: _vm.id_news },
        on: { hideModalNews: _vm.hideModalNews }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }